import React from 'react';

const ViewContainer = ({ routes }: Record<string, any>): React.ReactElement => (
  <>this is view page</>
);

export default ViewContainer;
